import { useCallback, useEffect, useState } from 'react';
import { getErrorMessage } from './axios';

/**
 * Loads a list from an API helper that returns `{ data: [...] }`.
 * Always resolves to an array and always clears `loading`, even when the request fails.
 */
export function useApiList(fetcher, errorText) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const reload = useCallback(() => {
    setLoading(true);
    setError('');
    return fetcher()
      .then((res) => setItems(Array.isArray(res?.data) ? res.data : []))
      .catch((err) => setError(getErrorMessage(err, errorText)))
      .finally(() => setLoading(false));
  }, [fetcher, errorText]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { items, loading, error, reload };
}
